import { CustomColumn } from '../../../../../../types/components/tables/tableTypes';
import RaptorStatusBox from '../../../../../feedback/RaptorStatusBox.component';
import { specifyStatus } from '../../../../../../utilities/generalMappings';
import type {
  EmirFundLevelTableRow,
  EmirMancoLevelTableRow,
} from './emirFundSummary.types';

export const emirMancoLevelTableColumns: CustomColumn<EmirMancoLevelTableRow>[] =
  [
    {
      title: 'Manco Name',
      field: 'mancoName',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      width: '34%',
    },
    {
      title: 'Limit',
      field: 'limit',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      title: 'Value',
      field: 'value',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      title: 'Percentage',
      field: 'percentageValue',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      title: 'Status',
      field: 'status',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      width: '15%',
      render: (rowData) => (
        <RaptorStatusBox status={specifyStatus(rowData.status)} />
      ),
    },
  ];

export function getEmirFundLevelTableColumns(
  clientName: string | null,
): CustomColumn<EmirFundLevelTableRow>[] {
  return [
    {
      title: 'Fund Id',
      field: 'fundId',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
      render: (rowData) =>
        clientName === 'mersenne' ? `fund${rowData.index}` : rowData.fundId,
    },
    {
      title: 'Fund Name',
      field: 'fundName',
      cellStyle: { textAlign: 'left' },
      headerStyle: { textAlign: 'center' },
    },
    {
      title: 'Limit',
      field: 'limit',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      title: 'Value',
      field: 'value',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      title: 'Percentage',
      field: 'percentageValue',
      cellStyle: { textAlign: 'center' },
      headerStyle: { textAlign: 'center' },
    },
    {
      title: 'Status',
      field: 'status',
      cellStyle: { textAlign: 'center' },
      width: '15%',
      render: (rowData) => (
        <RaptorStatusBox status={specifyStatus(rowData.status)} />
      ),
      headerStyle: { textAlign: 'center' },
    },
  ];
}
